import ModuleHeaderIcons from 'features/submissions/components/molecules/ModuleHeaderIcons/ModuleHeaderIcons';

export default ModuleHeaderIcons;
